import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { Observable } from 'rxjs/Observable';
import _ from 'lodash';

const CACHE_TIME: number = 3600;

export class IASWDServerPlugin extends SmartenitPlugin {
  private _maxDuration: number;

  public onInit() {
    this.getCacheZoneValues();
  }

  get maxDuration(): any {
    return this._maxDuration;
  }

  public startWarning(duration: number = 240): void {
    const payload = {
      Duration: duration,
      Mode: '0x71',
      StrobeDutyCycle: 50,
      StrobeLevel: '0x01'
    };
    this.executeMethod(
      this.componentId,
      this.processorName,
      'Startwarning',
      payload
    );
  }

  public stopWarning(): void {
    const payload = {
      Duration: 0,
      Mode: '0x00',
      StrobeDutyCycle: 0,
      StrobeLevel: '0x00'
    };
    this.executeMethod(
      this.componentId,
      this.processorName,
      'Startwarning',
      payload
    );
  }

  public getStatusPayload(): any {
    return ['MaxDuration'];
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const attribute = message && message.attributeOrMethod;

    const response = message && message.data && message.data.response;

    if (attribute === 'MaxDuration') {
      this._maxDuration = response.value;
      this.setCache(
        'MaxDuration',
        this._maxDuration,
        CACHE_TIME,
        undefined,
        timestamp
      );
      this._onUpdate.next({ maxDuration: this._maxDuration });
    }

    return this.state;
  }

  private getCacheZoneValues() {
    const cacheValues = [this.getCache('MaxDuration'), this.getCache()];

    Observable.forkJoin(cacheValues).subscribe((array) => {
      if (array && array[0] != null) {
        this._maxDuration = array[0];
      } else {
        this._maxDuration = 240;
      }

      if (array && array[1] != null) {
        this.state = array[1];
      } else {
        this.state = {};
      }

      this._onUpdate.next({
        maxDuration: this._maxDuration,
        state: this.state
      });
    });
  }

  public getMaxDuration() {
    this.getAttributeWithSubscribeOption(
      this.componentId,
      this.processorName,
      'MaxDuration',
      {},
      false,
      `cacheTTL=${CACHE_TIME}`
    );
  }

  public getConditionOptions(): any {
    return null;
  }

  public getConditionAttribute() {
    return null;
  }

  public getEffectOptions(): any {
    return [
      {
        displayName: _.get(
          this.translationService.getResource(),
          'AR.EFFECTS_NL.START_WARNING',
          ''
        ),
        name: 'Start Warning',
        parameterKey: [
          'Duration',
          'Mode',
          'WarningMode',
          'Strobe',
          'SirenLevel'
        ],
        requireDuration: true,
        value: {
          method: 'Startwarning',
          payload: {
            Duration: 0,
            Mode: '0x00',
            SirenLevel: '01',
            Strobe: '01',
            StrobeDutyCycle: 50,
            StrobeLevel: '0x01',
            WarningMode: '0xF'
          }
        },
        warning: [
          {
            WarningMeaning: 'Bell',
            WarningMode: '0xF',
            displayName: _.get(
              this.translationService.getResource(),
              'AR.CONDITIONS_NL.WARNING_MODE.BELL',
              ''
            )
          },
          {
            WarningMeaning: 'Burglar',
            WarningMode: '0x1',
            displayName: _.get(
              this.translationService.getResource(),
              'AR.CONDITIONS_NL.WARNING_MODE.BURGLAR',
              ''
            )
          },
          {
            WarningMeaning: 'Fire',
            WarningMode: '0x2',
            displayName: _.get(
              this.translationService.getResource(),
              'AR.CONDITIONS_NL.WARNING_MODE.FIRE',
              ''
            )
          },
          {
            WarningMeaning: 'Panic',
            WarningMode: '0x3',
            displayName: _.get(
              this.translationService.getResource(),
              'AR.CONDITIONS_NL.WARNING_MODE.PANIC',
              ''
            )
          }
        ]
      },
      {
        displayName: _.get(
          this.translationService.getResource(),
          'AR.EFFECTS_NL.STOP_WARNING',
          ''
        ),
        name: 'Stop Warning',
        parameterKey: [
          'Duration',
          'Mode',
          'WarningMode',
          'Strobe',
          'SirenLevel'
        ],
        requireDuration: false,
        value: {
          method: 'Startwarning',
          payload: {
            Duration: 0,
            Mode: '0x00',
            SirenLevel: '01',
            Strobe: '01',
            StrobeDutyCycle: 0,
            StrobeLevel: '0x00',
            WarningMode: '0xF'
          }
        },
        warning: [
          {
            WarningMeaning: 'Bell',
            WarningMode: '0xF',
            displayName: _.get(
              this.translationService.getResource(),
              'AR.CONDITIONS_NL..BELL',
              ''
            )
          },
          {
            WarningMeaning: 'Burglar',
            WarningMode: '0x1',
            displayName: _.get(
              this.translationService.getResource(),
              'AR.CONDITIONS_NL.WARNING_MODE.BURGLAR',
              ''
            )
          },
          {
            WarningMeaning: 'Fire',
            WarningMode: '0x2',
            displayName: _.get(
              this.translationService.getResource(),
              'AR.CONDITIONS_NL.WARNING_MODE.FIRE',
              ''
            )
          },
          {
            WarningMeaning: 'Panic',
            WarningMode: '0x3',
            displayName: _.get(
              this.translationService.getResource(),
              'AR.CONDITIONS_NL.WARNING_MODE.PANIC',
              ''
            )
          }
        ]
      }
    ];
  }

  public getEffectAttribute(): string | null {
    return null;
  }

  public getEffectMethod(context?: any): string | null {
    return null;
  }

  public isEffectActive(option: any, payload: any) {
    const mode = payload.Mode || '0xff';
    return (
      (option.name == 'Stop Warning' && mode == '0x00') ||
      (option.name == 'Start Warning' && mode != '0x00')
    );
  }
}
